import { DATE_FORMAT } from "helpers/common";
import React from "react";


// Generates a consistent color from a string (e.g. name) for the avatar background
const getAvatarColor = (name) => {
    const colors = [
        "#F56565", "#ED8936", "#ECC94B", "#48BB78",
        "#38B2AC", "#4299E1", "#667EEA", "#9F7AEA", "#ED64A6",
    ];
    if (!name) return "#A0AEC0";
    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
};

// Generates initials from a name (e.g. "Vivek Kumar" -> "VK")
const getInitials = (name) => {
    if (!name) return "?";
    const parts = name.trim().split(" ");
    const initials =
        parts.length > 1
            ? `${parts[0][0]}${parts[parts.length - 1][0]}`
            : parts[0][0];
    return initials.toUpperCase();
};

const Columns = ({ handleAdminStatus, handleEditHandler, deleteHandler, handleViewHandler, permissions }) => [
    {
        dataField: "profilePic",
        text: "Profile Pic",
        formatter: (_, row) => (
            <>
                {row.profilePic ? (
                    <img
                        src={row.profilePic}
                        alt={row.name || "Profile"}
                        style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            objectFit: "cover",
                        }}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = ""; // clear broken src
                            e.target.style.display = "none";
                            e.target.nextSibling.style.display = "inline-flex";
                        }}
                    />
                ) : null}
                <span
                    style={{
                        display: row.profilePic ? "none" : "inline-flex",
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        backgroundColor: getAvatarColor(row.name),
                        color: "#fff",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "13px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                    }}
                >
                    {getInitials(row.name)}
                </span>
            </>
        ),
    },
    {
        dataField: "name",
        text: "Name",
        formatter: (_, row) => <span className="text">{row.name}</span>,
    },
    {
        dataField: "email",
        text: "Email",
        formatter: (_, row) => <span className="text">{row.email}</span>,
    },
    {
        dataField: "role",
        text: "Role",
        formatter: (_, row) => <span className="text">{row.role}</span>,
    },
    {
        dataField: "status",
        text: "Status",
        formatter: (_, row) => {
            const isActive = row?.status === "active";

            return isActive ? (
                <button
                    className="fas fa-toggle-on"
                    style={{
                        fontSize: "20px",
                        color: "green",
                        backgroundColor: "#fff",
                        border: "none",
                    }}
                    title="Active"
                    onClick={() => handleAdminStatus(row, "blocked")}
                ></button>
            ) : (
                <button
                    className="fas fa-toggle-off"
                    style={{
                        fontSize: "20px",
                        color: "red",
                        backgroundColor: "#fff",
                        border: "none",
                    }}
                    title="Blocked"
                    onClick={() => handleAdminStatus(row, "active")}
                ></button>
            );
        },
    },
    {
        dataField: "roleName",
        text: "Role Name",
        formatter: (_, row) => <span className="text">{row.roleName}</span>,
    },
    {
        text: "Last Login",
        dataField: "lastLoginAt",
        formatter: (_, row) => row.lastLoginAt && DATE_FORMAT(row.lastLoginAt),
    },
    {
        text: "Created At",
        dataField: "date_created_utc",
        formatter: (_, row) => row.createdAt && DATE_FORMAT(row.createdAt),
    },
    {
        text: "Action",
        dataField: "action",
        formatter: (_, row) => (
            <>
                <button
                    className="fas fa-eye"
                    style={{
                        fontSize: "16px",
                        backgroundColor: "#fff",
                        border: "none",
                    }}
                    title="View"
                    onClick={() => handleViewHandler(row)}
                ></button>
                {permissions?.edit ?
                    <button
                        className="fas fa-pen"
                        style={{
                            fontSize: "16px",
                            backgroundColor: "#fff",
                            border: "none",
                        }}
                        title="Edit"
                        onClick={() =>
                            handleEditHandler(row)
                        }
                    ></button>
                    : null}
                {permissions?.delete ? (
                    <button
                        className="fas fa-trash-alt"
                        style={{
                            backgroundColor: "#fff",
                            border: "none",
                        }}
                        title="Delete"
                        onClick={() => deleteHandler(row._id)}
                    ></button>
                ) : null}
            </>
        ),
    },
];
export default Columns;